<h3 mat-dialog-title>Enable Google Authenticator</h3>

<mat-dialog-content>
    <app-google-auth-setup-step (completed)="onCompleted()"
                                (cancelled)="onCancelled()"></app-google-auth-setup-step>
</mat-dialog-content>
